import { MetricsDashboard, ViolationsTable } from '../../../components/ViolationsReports';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployees } from '../../../redux/actions/employeesActions';
import { selectStatus } from '../../../redux/slices/employeesSlice';
import {
  selectViolations,
  selectViolationsStatus,
  setSelectedViolation,
} from '../../../redux/violationsReport/violationsReportSlice';

import {
  VioltionsReportContainer,
  ReportsViolationsTableContainer,
  ReportsViolationsContent,
  StyledBox,
} from './ViolationsReports.styles';

import { groupViolationsByType } from '../../../utils/helpers/reports/helperViolationsReports';
import Spinner from '../../../assets/svg/spinner';
import { selectCurrentVenue } from '../../../redux/slices/currentUserSlice';
import { fetchViolations } from '../../../redux/violationsReport/violationsThunks';

const ViolationsReports = () => {
  const dispatch = useDispatch();

  const currentVenue = useSelector(selectCurrentVenue);
  const venueID = currentVenue?.id;
  // States
  const [activeFilter, setActiveFilter] = useState('ALL');

  // selectors
  const violations = useSelector(selectViolations);
  const violationsStatus = useSelector(selectViolationsStatus);
  const isEmployeesLoading = useSelector(selectStatus) === 'loading';

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const handleSelectViolation = useCallback(
    (violation) => {
      dispatch(setSelectedViolation(violation));
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(fetchViolations(venueID));
  }, [dispatch, venueID]);

  // Variables
  const isLoading = violationsStatus === 'loading';

  // Validate if any data is loading
  const isAnyDataLoading = isEmployeesLoading || isLoading;

  // Caclulate the number of violations by type
  const violationsByType = useMemo(() => groupViolationsByType(violations), [violations]);

  const handleFilterChange = useCallback((filterType) => {
    setActiveFilter(filterType);
  }, []);

  return (
    <VioltionsReportContainer>
      <ReportsViolationsTableContainer>
        <ReportsViolationsContent>
          <MetricsDashboard
            countViolationsByType={violationsByType}
            onFilterChange={handleFilterChange}
            activeFilter={activeFilter}
          />
          {isAnyDataLoading ? (
            <StyledBox>
              <Spinner />
            </StyledBox>
          ) : (
            <ViolationsTable
              violations={violationsByType[activeFilter]?.items || []}
              isLoading={isLoading}
              onViolationClick={handleSelectViolation}
            />
          )}
        </ReportsViolationsContent>
      </ReportsViolationsTableContainer>
    </VioltionsReportContainer>
  );
};

export default React.memo(ViolationsReports);
